import React from 'react'
import { Grid } from '@material-ui/core'

import {
  Checkbox,
} from 'ui/components'

import { PANEL_ENVS } from 'utils/constants/environments'

export default ({ docType, onChange, withOnlyPeps }) => {
  const renderCheckboxOnlyPep = () => {
    if (docType === PANEL_ENVS.CNPJ) return null

    return (
      <Checkbox
        label="Filtrar apenas consultas com PEP"
        value={withOnlyPeps}
        onClick={(checked) => onChange('with_only_peps', checked)}
      />
    )
  }

  const renderGrid = () => {
    if (docType === PANEL_ENVS.CNPJ) return null

    return (
      <React.Fragment>
        <Grid item xs={12} sm={4}>
          <p>Serviços</p>
        </Grid>

        <Grid item xs={12} sm={8}>
          {renderCheckboxOnlyPep()}
        </Grid>
      </React.Fragment>
    )
  }

  return (
    renderGrid()
  )
}
